// api/activities.ts
import { fetchAPI } from "./utils";
import {
    GetActivitiesParams,
    CreateActivityParams,
    UpdateActivityParams,
    DeleteActivityParams,
} from "../types/requestInputs";
import {
    GetActivitiesResponse,
    CreateActivityResponse,
    UpdateActivityResponse,
    DeleteActivityResponse,
} from "../types/requestsOutputs";

// Fetch all activities
export const getActivities = async ({ token }: GetActivitiesParams): Promise<GetActivitiesResponse> => {
    return fetchAPI<GetActivitiesResponse>("/get-activities", "GET", undefined, token);
};

// Create a new activity
export const createActivity = async ({ token, payload }: CreateActivityParams): Promise<CreateActivityResponse> => {
    return fetchAPI<CreateActivityResponse>("/create-activity", "POST", payload, token);
};

// Update an existing activity
export const updateActivity = async ({ token, id, payload }: UpdateActivityParams): Promise<UpdateActivityResponse> => {
    return fetchAPI<UpdateActivityResponse>(`/update-activity`, "POST", { ...payload, activityPCVId: id }, token);
};

// Delete a activity
export const deleteActivity = async ({ token, id }: DeleteActivityParams): Promise<DeleteActivityResponse> => {
    return fetchAPI<DeleteActivityResponse>(`/delete-activity`, "POST", { activityPCVId: id }, token);
};
